// @core/api/endpoints/document/start_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineExecutionResponse,
  StartPipelineRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Start pipeline
 * Creates a pipeline execution for a document. The first stage becomes active and actors are notified. Only one pipeline execution can be active per document at a time.
 */
export async function StartPipeline(
  target_type: string,
  target_id: string,
  pipeline_id: string,
  data: StartPipelineRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/pipelines/:pipeline_id/start`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
